module.exports = __webpack_public_path__ + "assets/StarEMovesIcon.54740b83353d1907c04f321bf0b7205b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/stars/StarEMovesIcon.svg
// module id = 91
// module chunks = 0